import { MutableRefObject, forwardRef, memo } from 'react';
import { TAutocomplete } from './types';
import AutocompleteContextProvider from './AutocompleteContext';
import Body from './Body';

const Autocomplete = forwardRef<HTMLElement, TAutocomplete>((props, ref) => {
  const actualProps: TAutocomplete = {
    ...props,
    onLoadData:
      props.onLoadData ??
      ((searchString) => {
        return (props.initialOptions ?? []).filter(
          (current) =>
            current.label.toLowerCase().indexOf(searchString.toLowerCase()) !==
            -1,
        );
      }),
    showSpinner: props.showSpinner ?? !!props.onLoadData,
  };
  return (
    <AutocompleteContextProvider props={actualProps}>
      <Body
        props={actualProps}
        mainRef={ref as unknown as MutableRefObject<HTMLElement>}
      />
    </AutocompleteContextProvider>
  );
});

export default memo(Autocomplete);
